// extracted by mini-css-extract-plugin
export default {"card":"technologies_card__HO+bJ"};